<template>
  <div class='booking-details-landlord__documents-row'>

    <span class='booking-details-landlord__checkbox-label line-clamp-1'>{{ document.name }}</span>
    <div class='booking-details-landlord__documents-actions'>
      
      <a v-if="document.document_url.slice(-3).toLowerCase()==='pdf' || document.pdf ==1"
                  :data-rel="'lightcase:myCollection' + document.id + 'desktop'"
                  class='theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2'
                  :title='document.name'
                  :href='document.document_url'
                ><i class='icon-eye' style='font-size: 20px;'></i>
                <span class="hidden lg:block">{{ locales && locales.common && locales.common.view}}</span>
                <v-lightcase-holder
                  :current-document='document'
                  :disable-rotate='true'
                  :image-src='document.document_url'
                  :name="'box-' + document.id"
                />
              </a>
      <a v-else :href="'#box-' + document.id" :data-rel="'lightcase:myCollection' + document.id + 'desktop'" class='theme-btn theme-btn--small theme-btn--tertiary inline-flex gap-0 lg:gap-2'>
        <i class='icon-eye' style='font-size: 20px;'></i>
        <span class="hidden lg:block">{{ locales && locales.common && locales.common.view}}</span>
        <v-lightcase-holder
          :current-document='document'
          :disable-rotate='true'
          :image-src='document.document_url'
          :name="'box-' + document.id"
        />
      </a>

      <a class="booking-details-landlord__documents-actions-dots theme-btn theme-btn--square--small theme-btn--gray lg:hidden" data-feature="open-modal" data-target="export-file-modal">
        <i class='icon-dots-horizontal' style='font-size: 20px;'></i>
      </a>

      <div class="booking-details-landlord__documents-actions-buttons">
        <button class="theme-btn theme-btn--small theme-btn--white" @click="download($event, 'pdf'); return false;" :data-id="document.id">PDF</button>
        <button class="theme-btn theme-btn--small theme-btn--white" @click="download($event, 'zip'); return false;" :data-id="document.id">ZIP</button>
        <!-- <button @click="printImage(document.url); return false;" class="theme-btn theme-btn--small theme-btn--white hidden md:block">PRINT</button> -->
        <button @click="print($event); return false;" :data-id="document.id" class="theme-btn theme-btn--small theme-btn--white hidden md:block">PRINT</button>
      </div>

    </div>

    <div class="modal modal--bottom" data-feature="modal" data-name="export-file-modal">
      <div class="modal__content" data-feature="modal-active-area">
        <button class="modal__close" data-feature="close-modal" data-target="export-file-modal">
          <i class="icon-close"></i>
        </button>
        <h3 class="section-title-sm mb-2">Export file</h3>
        <p class="text-[#7B7C85] mb-4">{{ document.name }}</p>
        <div class="flex gap-2">
          <button class="theme-btn theme-btn--white theme-btn--block" @click="download($event, 'pdf'); return false;" >PDF</button>
          <button class="theme-btn theme-btn--white theme-btn--block" @click="download($event, 'zip'); return false;">ZIP</button>
          <!-- <button @click="printImage(document.document_url); return false;" class="theme-btn theme-btn--small theme-btn--white hidden lg:block">PRINT</button> -->
          <button @click="print($event); return false;" :data-id="document.id" class="theme-btn theme-btn--small theme-btn--white hidden lg:block">PRINT</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      document: {
        default: {},
        type: Object,
      },
      booking: {
        default: {},
        type: Object,
      },
      landlordId: {
        default: null,
        type: String,
      },
      token: {
            default: '',
            Type: String,
      },
    },
    computed: {
      ...mapGetters(["locales"]),
    },
    data() {
      return {};
    },
    methods: {
      imageToPrint(source) {
        return "<html><head><scri"+"pt>function step1(){\n" +
                "setTimeout('step2()', 10);}\n" +
                "function step2(){window.print();window.close()}\n" +
                "</scri" + "pt></head><body onload='step1()'>\n" +
                "<img src='" + source + "' /></body></html>";
      },
      printImage(source) {
        var pwa = window.open(source, "_new"); 	
        pwa.document.open();
        pwa.document.write("<html><head><scri"+"pt>function step1(){\n" + "setTimeout('step2()', 10);}\n" + "function step2(){window.print();window.close()}\n" + "</scri" + "pt></head><body onload='step1()'>\n" + "<img src='" + source + "' /></body></html>");
        pwa.document.close()
      },
      print: function(e){               
            // let form = $('.tenant-form').first();
            let data = '_token='+this.token+'&bookingId='+this.booking.id+'&landlordId='+this.landlordId+'&fileId[]='+e.target.getAttribute('data-id');
            data = data + "&type=PRINT";
            $.ajax({
                url: '/bookings/download-document',
                method: 'post',
                data: data,
                success: function (result) {
                  var w = window.open(result, "_new");
                  if (navigator.appName == 'Microsoft Internet Explorer') window.print();
                  else w.print();
                }
            });
         },
         download: function(e, type){               
            // let form = $('.tenant-form').first();
            let data = '_token='+this.token+'&bookingId='+this.booking.id+'&landlordId='+this.landlordId+'&fileId[]='+e.target.getAttribute('data-id');
            data = data + "&type="+type;
            $.ajax({
                url: '/bookings/download-document',
                method: 'post',
                data: data,
                // contentType:false,
                processData:false,
                success: function (response) {
                  var link = document.createElement("a");
                  link.download = 'download.'+type;
                  link.href = response;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  // delete link;
                }
            });
         },

    },
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/BookingDetailsDocumentLandlord.vue